import { Box } from "@mui/material";
import type { InlineBannerSlot } from "@/content/dashboardBannerOptions";
import { useDashboardBanner } from "../runtime/useDashboardBanner";
import { InlineBanner } from "../templates/InlineBanner";
import { visualOf } from "./bannerIcons";

/**
 * A place in a page where an Inline banner can go, filled by the runtime with
 * the banner published for this slot. An empty slot draws nothing, so it
 * leaves no gap in the page.
 */
export const InlineSlot = ({ slot }: { slot: InlineBannerSlot }) => {
  const { banner, followCta, close } = useDashboardBanner({
    template: "inline",
    slot,
  });

  if (!banner) return null;

  return (
    <Box width="100%" data-testid={`inline-slot-${slot}`}>
      <InlineBanner
        title={banner.title}
        text={banner.text ?? undefined}
        ctaLabel={banner.cta.label}
        onCtaClick={() => followCta(banner)}
        onClose={banner.closePeriod ? () => close(banner) : undefined}
        variant={banner.style}
        visual={visualOf(banner.visual)}
      />
    </Box>
  );
};
